import { useState } from 'react';

export function useCadernoTree() {
  const [editingNodeId, setEditingNodeId] = useState(null);
  const [editingNodeValue, setEditingNodeValue] = useState('');
  // "modified" removido das opções válidas (22/08/2026, pedido do
  // titular): ordenar por updatedAt fazia o caderno pular de posição toda
  // vez que o campo mudava (inclusive por engano, ex.: só abrir o
  // caderno) — "ordem fixa" é mais previsível. Um valor "modified" antigo
  // ainda salvo no sessionStorage de alguma sessão anterior cai no
  // fallback 'created' abaixo, sem precisar de migração manual.
  // 'status' adicionado em 12/09/2026 (MC103) — agrupa por Ativo/Suspenso/
  // Recurso/Liminar/Sem Status/Arquivado, mesma ordem do Kanban.
  const [workspaceSortMode, setWorkspaceSortMode] = useState(() => {
    try { const s = window.sessionStorage.getItem('rda_cadernoSortMode'); if (s === 'created' || s === 'alpha' || s === 'numero' || s === 'status') return s; } catch {}
    return 'created';
  });

  return {
    editingNodeId, setEditingNodeId,
    editingNodeValue, setEditingNodeValue,
    workspaceSortMode, setWorkspaceSortMode,
  };
}
